// 物流公司
export const expressCompanyOpts = [
    {
        value: '圆通速递',
        label: '圆通速递',
    },
    {
        value: '申通快递',
        label: '申通快递',
    },
    {
        value: '中通快递',
        label: '中通快递',
    },
    {
        value: '韵达快递',
        label: '韵达快递',
    },
    {
        value: '极兔速递',
        label: '极兔速递',
    },
    {
        value: '顺丰速运',
        label: '顺丰速运',
    },
    {
        value: '京东快递',
        label: '京东快递',
    },
    {
        value: '中国邮政',
        label: '中国邮政',
    },
    {
        value: 'EMS',
        label: 'EMS',
    },
    {
        value: '安能物流',
        label: '安能物流',
    },
    {
        value: '德邦物流',
        label: '德邦物流',
    },
    {
        value: '宅急送',
        label: '宅急送',
    },
    {
        value: '百世快递',
        label: '百世快递',
    },
    {
        value: '跨越速运',
        label: '跨越速运',
    },
    {
        value: '丰网速运',
        label: '丰网速运',
    },
];

// 商品类型
export const goodsTypeObj = {
    PHYSICAL_GOODS: '实物商品',
    ELECTRONIC_COUPON: '电子券',
    SERVICE_PACK: '服务套餐',
};
// 订单状态
export const orderStatus = [
    {
        label: '全部',
        value: null,
    },
    {
        label: '待付款',
        value: 'PENDING_PAY',
        color: 'primary',
    },
    {
        label: '配货中',
        value: 'IN_DISTRIBUTION',
        color: 'warning',
    },
    {
        label: '待发货',
        value: 'TO_BE_DELIVERED',
        color: 'primary',
    },
    {
        label: '待收货',
        value: 'TO_BE_RECEIVED',
        color: 'primary',
    },
    {
        label: '已取消',
        value: 'CANCELLED',
        color: 'info',
    },
    {
        label: '退款中',
        value: 'REFUNDING',
        color: 'danger',
    },
    {
        label: '已退款',
        value: 'REFUNDED',
        color: 'info',
    },
    {
        label: '已完成',
        value: 'COMPLETED',
        color: 'success',
    },
];
